import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    maxWidth: 320
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: theme.spacing(1),
    fontSize: 12,
    lineHeight: 1.4
  },
  label: {
    fontWeight: 700
  },
  // Lead-in line explaining what the values below represent.
  note: {
    fontSize: 12,
    lineHeight: 1.4,
    color: theme.colorPalette.beige_75
  },
  // Single-line bodies (e.g. "Term not effective yet") that have no label/value rows.
  singleLine: {
    fontSize: 12,
    lineHeight: 1.4
  },
  loading: {
    fontStyle: 'italic',
    color: theme.colorPalette.beige_75
  },
  error: {
    color: theme.colors.error
  }
}));
